import { useMemo } from 'react';

import { useClusters } from '@cast/shared-cluster-context-data-access';
import { K8sProvider } from '@cast/shared-types';

import { useIsClusterDemoMode } from '@cast/infrastructure-demo';

export const useFilteredProvidersForOrganization = <T extends K8sProvider>(
  providers: T[]
) => {
  const { clusters } = useClusters();
  const isClusterDemoMode = useIsClusterDemoMode();
  return useMemo(() => {
    if (isClusterDemoMode) {
      return [];
    }

    return providers.filter((provider) =>
      clusters.some((cluster) => cluster.providerType === provider)
    );
  }, [clusters, providers, isClusterDemoMode]);
};
